import { LegalPage, LegalSection } from "./LegalShared";

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      section="§ Codex · Terms of Service"
      title="Terms of the Lyceum."
      subtitle="By entering the HEXIS OS Meta-Architect, you accept the disciplines below."
    >
      <LegalSection n="I" title="The Compact">
        HEXIS OS is an educational &amp; productivity platform for forging software through the
        six disciplines (Lean · Six Sigma · Design Thinking · Systems Thinking · Chaos Engineering
        · Agile/Scrum). You may use it to create, audit, and deploy code for your own purposes.
      </LegalSection>

      <LegalSection n="II" title="Your Account">
        You are responsible for the credentials you create (email/password) or grant (Google OAuth).
        Share them and you share the rite. Keep them and the passage is yours alone. Bring-your-own
        tokens (DeepSeek, GitHub, Vercel, Railway) are stored encrypted-at-rest in our database
        and used strictly on your behalf — never shared or logged in plaintext.
      </LegalSection>

      <LegalSection n="III" title="Your Artifacts">
        Code generated through your sprints remains <em>yours</em>. HEXIS OS claims no license
        over your artifacts, audits, or seals. Public seals you mark as such are discoverable
        via the Leaderboard and their share URLs; revert to Private at any time from the Sprint
        panel and anonymous access is revoked.
      </LegalSection>

      <LegalSection n="IV" title="Forbidden Conduct">
        Do not use HEXIS OS to generate or deploy: malware, phishing kits, content depicting
        minors, instruments of fraud, or anything that materially harms another person. We reserve
        the right to suspend accounts that breach this clause without notice.
      </LegalSection>

      <LegalSection n="V" title="Third-Party Services">
        HEXIS OS routes to external providers (Anthropic Claude, DeepSeek, Vercel, Railway,
        GitHub). Your use of those providers is governed by their respective terms. We proxy your
        tokens to their APIs only for the actions you explicitly initiate (deploy button, chat
        message, etc.).
      </LegalSection>

      <LegalSection n="VI" title="Availability &amp; Liability">
        The Lyceum is offered "as is", without warranty of uptime, accuracy, or fitness for
        a particular purpose. We are not liable for data loss, deployment failures, API-credit
        exhaustion, or consequential damages arising from your use of the service.
      </LegalSection>

      <LegalSection n="VII" title="Changes">
        These terms may evolve as HEXIS OS matures. Material changes will be announced on the
        Landing page and will take effect 14 days after posting.
      </LegalSection>

      <p style={{ fontStyle: "italic", fontSize: 14, color: "var(--muted)", textAlign: "center", marginTop: 14 }}>
        "The whole is greater than the sum of its parts." — Ἀριστοτέλης
      </p>
    </LegalPage>
  );
}
